import { render, staticRenderFns } from "./IconCashier.vue?vue&type=template&id=56460b70&lang=html&"
import script from "./IconCashier.vue?vue&type=script&lang=js&"
export * from "./IconCashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports